export default __webpack_public_path__ + "static/media/stuffcool-logo.faba67bd.svg";